import _ from 'lodash';

export function hasIntersection(arr1 = [], arr2 = []) {
  return _.intersection(arr1, arr2).length > 0;
}
export const isLastItem = (idx, items = []) => items.length === idx + 1;
export const isFirstItem = (idx) => idx === 0;

export function arrayMoveMutable(array, fromIndex, toIndex) {
  const startIndex = fromIndex < 0 ? array.length + fromIndex : fromIndex;

  if (startIndex >= 0 && startIndex < array.length) {
    const endIndex = toIndex < 0 ? array.length + toIndex : toIndex;

    const [item] = array.splice(fromIndex, 1);
    array.splice(endIndex, 0, item);
  }
}

export function arrayMove(array, fromIndex, toIndex) {
  const newArray = [...array];
  arrayMoveMutable(newArray, fromIndex, toIndex);
  return newArray;
}

export function ensureArray(value) {
  return Array.isArray(value) ? value : [value];
}
